// extracted by mini-css-extract-plugin
export default {"vehicleTypeId":"AddVehicule_vehicleTypeId__8P4ZR"};